<template>
    <div id="footer" class="text-accent">
        <section class="gt-sm">
            <div class="container">
                <div class="row justify-between items-start q-col-gutter-lg">
                    <div class="col-3">
                        <router-link to="/"><img :src="require('@/assets/img/logos/avenir-text.png')" class="q-mt-xs" /></router-link>
                    </div>
                    <div class="col-2 items-center">
                        <div class="text-subtitle2 text-bold text-uppercase q-mb-sm text-primary">Our Products</div>
                        <ul class="q-ma-none text-caption">
                            <li class="nav-item"><router-link to="/" class="footer-link">All Products</router-link></li>
                            <li class="nav-item"><router-link to="/product/loopcad" class="footer-link">LoopCAD</router-link></li>
                            <li class="nav-item"><router-link to="/product/heatcad" class="footer-link">HeatCAD</router-link></li>
                            <li class="nav-item"><router-link to="/product/plumbingcad" class="footer-link">PlumbingCAD</router-link></li>
                            <li class="nav-item"><router-link to="/product/lengthwise" class="footer-link">LengthWise</router-link></li>
                            <li class="nav-item"><router-link to="/product/custom" class="footer-link">Custom Software</router-link></li>
                        </ul>
                    </div>
                    <div class="col-2 items-center">
                        <div class="text-subtitle2 text-bold text-uppercase q-mb-sm text-primary">Support</div>
                        <ul class="q-ma-none text-caption">
                            <li class="nav-item"><router-link to="/support/supporthome" class="footer-link">Support Home</router-link></li>
                            <li class="nav-item"><router-link to="/support/faqs" class="footer-link">FAQs</router-link></li>
                            <li class="nav-item"><router-link to="/support/tutorial" class="footer-link">Video Tutorials</router-link></li>
                            <li class="nav-item"><router-link to="/support/webinars" class="footer-link">Webinars</router-link></li>
                            <li class="nav-item"><router-link to="/activation/loopcad" class="footer-link">Program Activation</router-link></li>
                            <li class="nav-item"><router-link to="/support/revisionhistory" class="footer-link">Revision History</router-link></li>
                            <li class="nav-item"><router-link to="/support/ticket" class="footer-link">Request Help</router-link></li>
                        </ul>
                    </div>
                    <div class="col-2 items-center">
                        <div class="text-subtitle2 text-bold text-uppercase q-mb-sm text-primary">Resources</div>
                        <ul class="q-ma-none text-caption">

                            <li class="nav-item"><router-link to="/download/loopcad" class="footer-link">LoopCAD Downloads</router-link></li>
                            <li class="nav-item"><router-link to="/download/heatcad" class="footer-link">HeatCAD Downloads</router-link></li>
                            <li class="nav-item"><router-link to="/download/plumbingcad" class="footer-link">PlumbingCAD Downloads</router-link></li>
                            <li class="nav-item"><router-link to="/store" class="footer-link">Pricing</router-link></li>
                            <li class="nav-item"><router-link to="/acca" class="footer-link">ACCA Approved Manual J</router-link></li>
                            <li class="nav-item"><router-link to="/f280" class="footer-link">CSA F280 Verified</router-link></li>
                        </ul>
                    </div>
                    <div class="col-2 items-center">
                        <div class="text-subtitle2 text-bold text-uppercase q-mb-sm text-primary">Company</div>
                        <ul class="q-ma-none text-caption">
                            <li class="nav-item"><router-link to="/about" class="footer-link">About Us</router-link></li>
                            <li class="nav-item"><router-link to="/contact" class="footer-link">Contact Us</router-link></li>
                            <li class="nav-item"><router-link to="/news" class="footer-link">Latest News</router-link></li>
                        </ul>
                    </div>
                </div>
            </div>
        </section>
        <section class="bg-grey-3">
            <div class="container">
                <div class="row justify-between items-start q-col-gutter-xl">
                    <div v-if="showSubscribe" class="col-sm-6 col-md-4 col-xs-12 items-center">

                        <div class="text-h6 text-bold q-mb-sm"><i class="mdi mdi-email q-mx-sm" />Join Our Email List</div>
                        <p>Keep updated and subscribe to our mailing list</p>

                        <div class="row">
                            <q-btn style="margin-top: 1px;" color="primary" label="Join Email List" class="col-xs-12 col-sm-auto"
                                   @click="showSubscribeDialog = true" />
                            <dialog-subscribe :show.sync="showSubscribeDialog" />
                        </div>
                    </div>
                    <div class="col-sm-6 col-md-5 col-xs-12 items-center">
                        <div class="text-subtitle1 text-bold q-mb-md">Legal</div>

                        <p>&copy; {{date.getFullYear()}} Avenir Software Inc. All rights reserved</p>
                        <p class="trademark-notice-text text-grey-8">ACCA, Manual J and Powered by ACCA Manual J are registered trademarks of the Air Conditioning Contractors of America. All rights reserved.</p>
                        <p class="trademark-notice-text text-grey-8">CSA and F280 are trademarks owned by, and CSA F280-12 is copyrighted by, the Canadian Standards Association. All rights reserved.</p>

                        <router-link to="/terms">Terms</router-link><span class="q-mx-sm">|</span>
                        <router-link to="/privacy">Privacy</router-link>
                        <div>
                            <q-btn v-if="isTestSite" label="Throw Client Side Error" @click="throwClientTestError()" class="q-my-md q-mr-sm bg-red text-white" style="width: 175px; font-size: 0.7em;" />
                            <q-btn v-if="isTestSite" label="Throw Server Side Error" @click="throwServerTestError()" class="q-my-md bg-red text-white" style="width: 175px; font-size: 0.7em;" />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>
<script>

    import dialogSubscribe from '@/components/dialogs/DialogSubscribe'
    export default {
        name: 'app-footer',
        components: {
            dialogSubscribe
        },
        data() {
            return {
                date: new Date(),
                showSubscribeDialog: false,
                isTestSite: (process.env.VUE_APP_ISTESTSITE == 'true') ? true : false,
            }
        },
        methods: {
            throwClientTestError() {
                throw 'Client Side Test Error Thrown!';
            },
            throwServerTestError() {
                this.$store.dispatch('throwTestServerError')
            }
        },
        computed: {
            screenSize() {
                return this.$q.screen
            },
            isSectionTableSm() { return this.$store.getters.isSectionTableSm },
            showSubscribe() {
                if (this.screenSize.xs && this.$route.path !== '/') return false
                return true
            }
        }

    }
</script>
<style scoped>

    #footer ul {
        list-style: none;
        padding: 0;
    }

    .trademark-notice-text {
        font-size: 0.75em;
        font-weight: 400;
        margin-bottom: 8px;
    }
</style>
